/** Copyright 2025 Midas Healthcare Solutions - All Rights Reserved **/
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { featureFlagsAdapter, FeatureFlagsState, FEATURE_FLAGS_KEY } from './feature-flags.reducer';
import { FeatureFlagName } from '@midas/shared/common';

const { selectAll } = featureFlagsAdapter.getSelectors();

const getFeatureFlagsState = createFeatureSelector<FeatureFlagsState>(FEATURE_FLAGS_KEY);

export const getFeatureFlags = createSelector(getFeatureFlagsState, (state: FeatureFlagsState) => ({
  featureFlags: selectAll(state.featureFlags),
  loaded: state.loaded,
  loading: state.loading,
}));

export const isFeatureEnabled = (featureName: FeatureFlagName) =>
  createSelector(
    getFeatureFlagsState,
    (state: FeatureFlagsState) => state.featureFlags.entities[featureName]?.isEnabled ?? false,
  );
